import { types } from '../types/types';

type WsState = { wsClient?: unknown };
type WsAction = { type: string; payload?: { objWS?: unknown } };

export const websocketReducer = (state: WsState = {}, action: WsAction) => {
	switch (action.type) {
		case types.websocket:
			return {
				wsClient: action.payload ? action.payload.objWS : null, // el websocket se mantendrá mientras no se refresque la página
			};
		default:
			return state;
	}
};
